// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2aQ05","bigColWidth":"Table_bigColWidth__NkEB-","biggerColWidth":"Table_biggerColWidth__AheH_","row":"Table_row__2RVJu","col":"Table_col__2sXec"};